import { handleActions } from 'redux-actions';

const initialState = {
  message: '',
};

const flash = handleActions(
  {
    ADD_LOADER_MESSAGE: (state, action) =>
      Object.assign({}, state, {
        message: action.payload.message,
      }),

    CLEAR_LOADER_MESSAGE: () => initialState,
    AUTHENTICATION_LOGOUT: () => ({
      ...initialState,
    }),
  },
  initialState,
);

export default flash;



// WEBPACK FOOTER //
// ./src/store/reducers/Loader/index.js